import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'
import { InputBox } from 'components/chec'
import { Table } from 'components/patterns'
import { escapeRegExp } from 'utils/utils'
import strings from 'utils/strings.js'

import 'styles/AntOverrides.css'
import 'styles/ChecComponents.css'
import 'styles/FilterableTable.css'

export default class FilterableTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filter: '',
    }

    this.handleFilterInput = (e) => {
      this.setState({
        filter: e.target.value,
      })
    }
  }

  render() {
    let headerClass = 'filterable-table_header'

    if (this.props.hideFilter) {
      headerClass += ' filterable-table_header--no-filter'
    }

    const escapedFilter = escapeRegExp(this.state.filter)
    const filterRegex = new RegExp(escapedFilter, 'gi')
    const data = this.props.dataSource.filter((d) => {
      let match = false
      Object.keys(d).forEach((key) => {
        if (d[key] && d[key].toString().match(filterRegex)) match = true
      })
      return match
    })

    return (
      <FilterTableLayout className="filterable-table" width={this.props.width}>
        {this.props.title && (
          <div
            ref={(el) => {
              this.header = el
              return this.header
            }}
          >
            <h5 className={headerClass}>{this.props.title}</h5>
            {!this.props.hideFilter && (
              <form
                onSubmit={(e) =>
                  this.props.noSubmitOnEnter ? e.preventDefault() : e
                }
              >
                <InputBox
                  box
                  placeholder={strings.filter_by_id_or_keyword}
                  value={this.state.filter}
                  onChange={this.handleFilterInput}
                />
              </form>
            )}
          </div>
        )}
        <RowSelectStyleTable
          className={this.props.className}
          columns={this.props.columns}
          dataSource={data}
          pagination={false}
          yScroll={this.props.tableSize}
          onRow={(record) => ({
            onClick: () => this.props.onRowClick(record),
          })}
          rowClassName={(record) => (record.selected ? 'selected' : '')}
        />
      </FilterTableLayout>
    )
  }
}

const RowSelectStyleTable = styled(Table)`
  tr.selected td {
    background: #ffff99 !important;
    background-color: #ffff99 !important;
  }
`

const FilterTableLayout = styled.div((props) =>
  stylesIf(props.width, `width: ${props.width}`)
)

FilterableTable.defaultProps = {
  onRowClick: () => {},
}

FilterableTable.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  hideFilter: PropTypes.bool,
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRowClick: PropTypes.func,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  noSubmitOnEnter: PropTypes.bool,
  tableSize: PropTypes.number,
  width: PropTypes.string,
}
